import { render, staticRenderFns } from "./OrderSliderProductSkeleton.vue?vue&type=template&id=0db6c7f2&scoped=true&"
import script from "./OrderSliderProductSkeleton.vue?vue&type=script&lang=js&"
export * from "./OrderSliderProductSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./OrderSliderProductSkeleton.vue?vue&type=style&index=0&id=0db6c7f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db6c7f2",
  null
  
)

export default component.exports